import { render, staticRenderFns } from "./popStyle.vue?vue&type=template&id=53bfae3e&scoped=true"
import script from "./popStyle.vue?vue&type=script&lang=js"
export * from "./popStyle.vue?vue&type=script&lang=js"
import style0 from "./popStyle.vue?vue&type=style&index=0&id=53bfae3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bfae3e",
  null
  
)

export default component.exports